import React from "react";
import { Joyride, Step } from "react-joyride";

interface AppTourProps {
    run: boolean;
    steps: Step[];
    onJoyrideCallback: (data: any) => void;
}

export const AppTour: React.FC<AppTourProps> = ({ run, steps, onJoyrideCallback }) => {
    return (
        <Joyride
            run={run}
            steps={steps}
            continuous={true}
            onEvent={onJoyrideCallback}
            styles={{
                buttonPrimary: {
                    backgroundColor: "#00AA87",
                    fontSize: 13
                },
                buttonBack: {
                    color: "#00AA87",
                    fontSize: 13
                }
            }}
            options={{
                primaryColor: "#00AA87",
                textColor: "#333",
                zIndex: 10000,
                blockTargetInteraction: true,
                buttons: ["back", "close", "primary", "skip"]
            }}
        />
    );
};
